<template>
	<div class="page_container" :class="'p'+this.$route.name">
		<div class="page_hero p">
	  		<div>
	  			<h1>{{this.$route.meta.name}}</h1>
	  			<router-view class="sub_nav fade-in fade-out"></router-view>
	  			<div class="page_about">
  					<p v-html="presentation"></p>

  					<div class="actions">

					<router-link class="routerlink" to="/conduite/neph">
			  			<div class="action neph">
			  				<div class="title">
			  					<h3>N° NEPH</h3>
			  				</div>
			  				<div class="sub">
			  					<button>En savoir plus</button>
			  				</div>
			  			</div>
		  			</router-link>

		  			<router-link class="routerlink" to="/conduite/premiere_demande">
			  			<div class="action premiere_demande">
			  				<div class="title">
				  				<h3>Première demande de permis</h3>
				  			</div>
				  			<div class="sub">
				  				<button>En savoir plus</button>
				  			</div>
			  			</div>
		  			</router-link>

		  			<router-link class="routerlink" to="/conduite/duplicata">
			  			<div class="action duplicata_permis">
			  				<div class="title">
				  				<h3>Duplicata de permis de permis</h3>
				  			</div>
				  			<div class="sub">
				  				<button>En savoir plus</button>
				  			</div>
			  			</div>
		  			</router-link>

		  			<router-link class="routerlink" to="/conduite/renouvellement">
			  			<div class="action renouvellement">
			  				<div class="title">
				  				<h3>Renouvellement de permis</h3>
				  			</div>
				  			<div class="sub">
				  				<button>En savoir plus</button>
				  			</div>
			  			</div>
		  			</router-link>

		  			<router-link class="routerlink" to="/conduite/suspensions">
			  			<div class="action suspensions">
			  				<div class="title">
				  				<h3>Suspensions/annulations de permis</h3>
				  			</div>
				  			<div class="sub">
				  				<button>En savoir plus</button>
				  			</div>
			  			</div>
		  			</router-link>

		  			<router-link class="routerlink" to="/conduite/international">
			  			<div class="action international">
			  				<div class="title">
				  				<h3>Demande de permis international</h3>
				  			</div>
				  			<div class="sub">
				  				<button>En savoir plus</button>
				  			</div>
			  			</div>
		  			</router-link>

		  			<router-link class="routerlink" to="/conduite/codengo">
			  			<div class="action codengo">
			  				<div class="title">
				  				<h3>Coden'go</h3>
				  			</div>
				  			<div class="sub">
				  				<button>En savoir plus</button>
				  			</div>
			  			</div>
		  			</router-link>

		  			<router-link class="routerlink" to="/conduite/stages">
			  			<div class="action stages">
			  				<div class="title">
				  				<h3>Stages de récupération de points</h3>
				  			</div>
				  			<div class="sub">
				  				<button>En savoir plus</button>
				  			</div>
			  			</div>
		  			</router-link>


			  		</div>
  				</div>
  			</div>
	  	</div>
	</div>
</template>

<script>
	const fb = require('../firebaseConfig.js')
	import firebase from 'firebase'
export default {
	name: 'Conduite',
			data () {
			return {
				presentation:''
			}
		},
		methods: {
		},
		mounted () {
			if(Object.keys(this.$store.state.static).length === 0){
				firebase.auth().signInAnonymously()
      			.then(() => {
					// console.log("object empty")
					fb.db.collection('documents').doc(this.$route.meta.parent_name).get()
			  		.then(res => {
				  		this.presentation = res.data().presentation
			  		})
			  	})
			}else{
				// console.log("object not very empty my friend for conduite")
				var doc = this.$store.state.static[this.$route.meta.parent_name]
		  		this.presentation = doc.presentation
			}
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Conduite.vue